// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__jHire","container":"LayoutSideNavigation_container__3fbbn","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__mFYHQ"};